<template>
  <div class="md-layout">
    <md-dialog :md-active.sync="showDialog" id="new-interaction-dialog">
      <md-dialog-title>Interaction</md-dialog-title>
      <md-dialog-content>
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(createInteraction)">
            <div class="md-layout">
              <div class="md-layout-item md-size-40">
                <h6>Direction</h6>
                <md-radio
                  v-model="interaction.direction.value"
                  value="incoming"
                  class="md-primary"
                  >Incoming</md-radio
                >
                <md-radio
                  v-model="interaction.direction.value"
                  value="outgoing"
                  class="md-primary"
                  >Outgoing</md-radio
                >
                <h6>Interaction Type</h6>
                <md-field>
                  <md-select
                    v-model="interaction.type.value"
                    name="type"
                    id="type"
                  >
                    <md-option value="internal">Internal</md-option>
                    <md-option value="phone">Phone</md-option>
                    <md-option value="email">Email</md-option>
                    <md-option value="webform">Contact Form</md-option>
                    <md-option value="question">Question Form</md-option>
                    <md-option value="customize">Customize Tour Form</md-option>
                    <md-option value="social_media">Social Media</md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-60">
                <h6>Content</h6>
                <text-editor v-model="interaction.content" />
              </div>
            </div>
            <md-dialog-actions>
              <md-button class="md-primary md-dense" @click="cancel"
                >Cancel</md-button
              >
              <md-button type="submit" class="md-primary md-dense">{{
                updateButtonText
              }}</md-button>
            </md-dialog-actions>
          </form>
        </ValidationObserver>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<script>
import enquiryApi from "@/services/api/enquiry";

export default {
  name: "EnquiryInteractionCreateDialog",

  props: ["enquiry", "interaction", "showDialog"],

  data() {
    return {};
  },

  computed: {
    updateMode: function() {
      return this.interaction.id ? "UPDATE" : "CREATE";
    },
    updateButtonText: function() {
      return this.updateMode == "UPDATE" ? "Update" : "Create";
    }
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },

    createInteraction() {
      let save = null;
      let message = null;

      let args = {
        enquiry: this.enquiry,
        interaction: this.interaction
      };

      switch (this.updateMode) {
        case "UPDATE":
          save = enquiryApi.updateInteraction(args);
          message = "Updated!";
          break;

        default:
          save = enquiryApi.createInteraction(args);
          message = "Added!";
      }

      save.then(response => {
        this.$notify({
          timeout: 2500,
          message: message,
          icon: "thumb_up",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success"
        });

        this.$emit("update", {
          interaction: response.data,
          mode: this.updateMode
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.xmx-datepicker {
  width: 100%;
  padding-bottom: 12px;
}

#new-interaction-dialog {
  &::v-deep {
    .md-dialog-container {
      width: 768px;
    }

    .ProseMirror {
      // min-height: 200px;
      margin-bottom: 1rem;
    }
  }

  .md-radio {
    margin: 5px 15px 5px 0px;
  }

  h6 {
    margin: 0.5rem 0 0.5rem 0;
  }
}
</style>
